import useContractRow from './useContractRow'
import StatusCell from './StatusCell/StatusCell'
import StepsCell from './StepsCell/StepsCell'
import ContactCell from './ContactCell/ContactCell'
import OfferCell from './OfferCell/OfferCell'
import RowActions from './RowActions/RowActions'
import { Contract } from '../../../types'
import { BodyCell, ContractsTableRow } from '../styled-components'

interface ContractRowProps {
  contract: Contract
  getContracts: () => void
  formInitUrl: string
}

const ContractRow = ({ contract, getContracts, formInitUrl }: ContractRowProps) => {
  const { status, steps, contact, offer } = useContractRow(contract)

  return (
    <ContractsTableRow role='row'>
      <BodyCell role='cell'>
        <StatusCell {...status} />
      </BodyCell>
      <BodyCell role='cell'>
        <StepsCell steps={steps} />
      </BodyCell>
      <BodyCell role='cell'>
        <ContactCell {...contact} />
      </BodyCell>
      <BodyCell role='cell'>
        <OfferCell {...offer} />
      </BodyCell>
      <BodyCell role='cell'>
        <RowActions contract={contract} getContracts={getContracts} formInitUrl={formInitUrl} />
      </BodyCell>
    </ContractsTableRow>
  )
}

export default ContractRow
